import { ApiError, errorMessage } from '@/api/client'

export const SELECT_CLASS =
  'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-xs'

/** A Staff-area error, with the server's refusal code spelled out where it helps. */
export function staffErrorText(error: unknown): string {
  if (error instanceof ApiError && error.code !== undefined) {
    switch (error.code) {
      case 'reason_required':
        return 'The server wants a written reason of the required length.'
      case 'credit_cap_exceeded':
        return `${error.message} Ask a superadmin for a larger amount.`
      case 'subscription_live':
        return 'This account has a live Stripe subscription. Change the plan in Stripe, or cancel the subscription first: two sources must never fight over one account.'
      case 'staff_tier_required':
        return 'Your staff tier does not allow this.'
      case 'mfa_required':
        return 'Sign in with a second factor to use the staff console.'
      default:
        return error.message
    }
  }
  return errorMessage(error)
}
